module.exports = __webpack_public_path__ + "static/sportovni-den-2022-01-9c999e4916ab1071dc0c80dc837a18be.jpg";